/*
 * Section admin : emails de relance apres l'envoi du bilan.
 * 3 rappels doux, delais configurables, arret automatique si rendez vous
 * reserve ou desinscription. Donnees commerciales uniquement.
 * Les blocs visuels vivent dans RelanceSectionParts.jsx.
 */

import { useState } from "react";
import { toast } from "sonner";
import { adminPreviewRelance } from "@/lib/api";
import {
  RELANCE_LABELS,
  RelanceHeader,
  RelanceDelaysBlock,
  RelanceEmailCard,
  RelanceCancellationBlock,
  RelancePreviewDialog,
} from "@/components/admin/RelanceSectionParts";

const sectionClass = "rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-6 shadow-[var(--shadow-sm)] space-y-5";

export const RelanceSection = ({ relance, onPatch, onPatchEmail, onPatchDelay, onPatchCancellation, adminKey }) => {
  const [preview, setPreview] = useState(null); // { subject, html } | null
  const [previewLoading, setPreviewLoading] = useState(false);

  const openPreview = async (subject, body) => {
    if (!subject.trim() || !body.trim()) {
      toast.error("Aperçu impossible", { description: "Renseigne le sujet et le corps du message." });
      return;
    }
    setPreviewLoading(true);
    try {
      const data = await adminPreviewRelance(adminKey, subject, body);
      setPreview(data);
    } catch (e) {
      toast.error("Erreur", { description: "L'aperçu n'a pas pu être généré. Réessaie." });
    } finally {
      setPreviewLoading(false);
    }
  };

  return (
    <section className={sectionClass} data-testid="admin-relance-section">
      <RelanceHeader enabled={relance.enabled} onPatch={onPatch} />

      <RelanceDelaysBlock delays={relance.delays} onPatchDelay={onPatchDelay} />

      <div className="space-y-4">
        {relance.emails.map((email, index) => (
          <RelanceEmailCard
            key={`email-${RELANCE_LABELS[index]}`}
            email={email}
            index={index}
            delay={relance.delays[index]}
            previewLoading={previewLoading}
            onPreview={openPreview}
            onPatchEmail={onPatchEmail}
          />
        ))}

        <RelanceCancellationBlock
          cancellation={relance.cancellation}
          previewLoading={previewLoading}
          onPreview={openPreview}
          onPatchCancellation={onPatchCancellation}
        />
      </div>

      <p className="text-[11px] leading-relaxed text-[#9E9E9E]">
        Rappel : la salutation avec le prénom, le bouton de réservation et le lien de
        désinscription sont ajoutés automatiquement à chaque email. Règle éditoriale :
        aucun tiret dans les textes.
      </p>

      <RelancePreviewDialog preview={preview} onClose={() => setPreview(null)} />
    </section>
  );
};
